export default __webpack_public_path__ + "static/media/logo.07fdf8d5.png";